const i18n = {
	invitationTitle: {
		1 : "Приглашение пользователей в организацию",
		0 : "Запрашэнне карыстальнікаў у арганізацыю"
	},
	confirmText: {
		1 : "Вы действительно хотите отправить приглашение этому пользователю?",
		0 : "Вы сапраўды хочаце адправіць запрашэнне гэтаму карыстальніку?"
	},
	isAccepted: { 1 : "Решение",
		0 : "Рашэнне" },
	creationDate: {
		1 : "Дата создания приглашения",
		0 : "Дата стварэння запрашэння"
	},
	required: {
		1 : "Поле обязательно для заполнения.",
		0 : "Поле абавязкова для запаўнення."
	},
	startDate: {
		1 : "Дата создания от",
		0 : "Дата стварэння ад"
	},
	endDate: {
		1 : "Дата создания по",
		0 : "Дата стварэння да"
	},
	accept: {
		1 : "Принять",
		0 : "Прыняць"
	},
	dismiss: {
		1 : "Отклонить",
		0 : "Адхіліць"
	},
	yes: {
		1 : "Принял приглашение",
		0 : "Прыняў запрашэнне"
	},
	no: {
		1 : "Отклонил приглашение",
		0 : "Адхіліў запрашэнне"
	},
	wait: {
		1 : "Приглашение не просмотрено",
		0 : "Запрашэнне ня прагледжана"
	},
	invitationList: {
		1 : "Список всех отправленных приглашений",
		0 : "Спіс усіх адпраўленых запрашэнняў"
	},
	userName: {
		1 : "Имя приглашенного пользователя",
		0 : "Імя запрошанага карыстальніка"
	},
	confirmAcceptText: {
		1 : "Вы действительно хотите вступить в выбранную организацию?",
		0 : "Вы сапраўды хочаце ўступіць у выбраную арганізацыю?"
	},
	confirmDismissText: {
		1 : "Вы действительно хотите отклонить приглашение?",
		0 : "Вы сапраўды хочаце адхіліць запрашэнне?"
	},
	notDecision: {
		1 : "Не рассмотрено",
		0 : "Не разгледжана"
	},
	confirmAcceptText: {
		1 : "Вы действительно хотите вступить в выбранную организацию?",
		0 : "Вы сапраўды хочаце ўступіць у выбраную арганізацыю?"
	},
	confirmDismissText: {
		1 : "Вы действительно хотите отклонить приглашение?",
		0 : "Вы сапраўды хочаце адхіліць запрашэнне?"
	}
}

export default i18n
